__webpack_require__.p = "/app/my-bag-and-checkout/static/";